






















































import { format, parse } from "date-fns/esm";
import { defineComponent, ref } from "@vue/composition-api";

import { Item } from "@/tools/msa/models/item";
import { Document, Session } from "@/tools/msa/models";
import useHistory from "@/tools/msa/utils/history";
import { useMapForCodes } from "@/tools/msa/utils/repetitions";

import ItemForm from "@/tools/msa/components/table/ItemForm.vue";
import ItemTable from "@/tools/msa/components/table/ItemTable.vue";
import HistoryControls from "@/tools/msa/components/HistoryControls.vue";
import RepetitionsSwitch from "@/tools/msa/components/RepetitionsSwitch.vue";
import DocumentTabs from "@/tools/msa/components/DocumentTabs.vue";
import BaseTab from "@/components/BaseTab.vue";
import MetadataForm from "@/tools/msa/components/summary/MetadataForm.vue";
import { save, download, load } from "@/tools/msa/extensions/persistence";

interface Props {
  session: Session;
  document: Document;
  selected: Item | null;
}

enum TabOptions {
  ConceptList = 0,
  Summary = 1
}

export default defineComponent({
  name: "DocumentManager",
  components: {
    MetadataForm,
    BaseTab,
    DocumentTabs,
    RepetitionsSwitch,
    ItemForm,
    HistoryControls,
    ItemTable
  },
  props: {
    session: { type: Object, required: true },
    document: { type: Object, required: true },
    selected: { type: Object, default: () => null }
  },
  setup(props: Props) {
    console.log(props.session);

    const tab = ref<TabOptions>(TabOptions.Summary);

    const { history } = useHistory(props);

    const { map } = useMapForCodes(props);

    const showRepetitions = ref<boolean>(false);

    const remove = (removed: Item) =>
      history.push(
        history.state.value.current.filter(item => item !== removed)
      );

    const add = (form: any) =>
      history.push([
        ...history.state.value.current,
        {
          type: "msa_custom",
          document: props.document,
          name: form.name,
          date: format(parse(form.date, "y-M-d", new Date()), "M/d/y")
        }
      ]);

    return { showRepetitions, tab, history, map, add, remove };
  }
});
